import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION21: PdfComponent = {
  type: 'section',
  id: 's21',
  title: '21. Indemnity',
  content: [
    {
      type: 'bulletList',
      id: 's21bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'The Subscriber shall fully indemnify and on demand reimburse Kanda from and against all costs, claims, demands, liabilities, expenses, damages or losses (including without limitation consequential losses and loss of profit, and all interest, penalties, and legal and other professional costs and expenses reasonably and properly incurred) arising out of or in connection with:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'any breach by the Subscriber of its obligations under this Agreement;',
              },
              {
                copy: 'any failure by the Subscriber to follow the procedures set out in the Kanda Procedure Guide;',
              },
              {
                copy: 'any Credit Agreement (in whole or in part) financing goods and/or services that are not Permitted Goods and Services;',
              },
              {
                copy: 'the Customer named on the Credit Agreement (or an authorised third party) not receiving the Permitted Goods and Services at the agreed address on the Credit Agreement;',
              },
              {
                copy: "the Subscriber's failure to refund a Customer's deposit in relation to a Credit Agreement where the deposit has been paid to the Subscriber and the Subscriber fails to provide the Permitted Goods and Services or is otherwise in breach of this Agreement;",
              },
              {
                copy: "any liability of Kanda under a Broker Agreement in relation to defending, settling, or satisfying any claim threatened or made under sections 56 or 75 of the Consumer Credit Act 1974 (including, without limitation, costs associated with Customer complaints handled by the Financial Ombudsman Service), or as a result of any representation made by the Subscriber or as a result of the Subscriber's negligence or breach of contract;",
              },
              {
                copy: 'any original documentation, in whatever format, being tampered with by the Subscriber, whether with the intention of supporting the approval of an application or for any other purpose;',
              },
              {
                copy: 'the Subscriber issuing a credit note or making a refund to any Customer, including where a Customer has returned a product under a product safety recall (or similar);',
              },
              {
                copy: 'any breach by the Subscriber of the related contract(s) for sale between the Subscriber and a Customer, including any term of such contract(s) being illegal, void, or unenforceable;',
              },
              {
                copy: 'any error, omission, fraud, deceit, or negligence committed by the Subscriber in connection with, and resulting in, credit being made available to any Customer;',
              },
              {
                copy: 'the failure of the Subscriber to provide satisfactory evidence of proof of provision of their services as required under the Kanda Procedure Guide;',
              },
              {
                copy: 'the failure of the Subscriber to provide any Customer documentation required to be provided under this Agreement or under the Kanda Procedure Guide or as otherwise agreed between the Subscriber and Kanda, including (for the avoidance of doubt) where this leads to a claim by a Customer that the Credit Agreement is unenforceable; and',
              },
              {
                copy: 'any misrepresentation by the Subscriber to Kanda or any lender.',
              },
            ],
          },
        },
        {
          copy: 'Any indemnity claim made by Kanda shall be payable on demand and without prejudice to any other remedies available to Kanda.',
        },
        {
          copy: 'Kanda may, at its sole and absolute discretion, set off (in a manner described in clause 9 (Set-Off)) any monies due by it to the Subscriber against any amount due to it under this clause 21.',
        },
      ],
      prefix: '21',
    },
  ],
};
